import { Card, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core'
import React from 'react'
import { useStyles } from '../../style'
import { useHistory } from 'react-router-dom';
import ReactSelect from 'react-select'
import TableBdy from './TableBdy';
import { GrNext } from 'react-icons/gr'

function PurchaseTableBody(props:any) {
    const classes = useStyles()
  return (
    
        <TableContainer>
                <Table>
                    <TableHead className={classes.tablecolor}>
                        <TableRow>
                            <TableCell className={classes.tableHead}>
                                State
                            </TableCell>
                            <TableCell className={classes.tableHead}>
                                Rate center
                            </TableCell>
                            <TableCell className={classes.tableHead}>
                                Area Code(s)
                            </TableCell>
                            <TableCell className={classes.tableHead}>
                                Numbers Availble
                            </TableCell>
                            <TableCell className={classes.tableHead}>
                                Action
                            </TableCell>

                        </TableRow>
                    </TableHead>
                  <TableBody>
                    {
                        props.loading === false && props.tableData.map((item: any) => {
                            console.log("item",item)
                            return (
                                <TableBdy 
                                    item={item}
                                    key={item.id}
                                    loading={props.loading}
                                    handleChangeCities={props.handleChangeCities}
                                    onClickViewNumber={() => props.onClickViewNumber(item)}
                                />
                            )
                        })
                    }
                           
                    </TableBody> 
                        
                </Table>
                {
                    props.loading ? <div className='loader_class'>
                        <div style={{ width: "100%",marginLeft: '130px', textAlign: "center" }}>
                                <CircularProgress />
                            </div>
                    </div> : props.tableData.length <= 0 && <p style={{ textAlign: 'center' }}>No Data</p>
                }
                {props.tableData.length > 0 ?
                    <div style={{ float: "right", margin: "15px", cursor: "pointer", display: "flex" }} onClick={props.handleChangeCities}>
                    <Typography style={{ marginTop: "-4px" }}>Next</Typography> <GrNext onClick={props.handleChangeCities} />
                    </div> : ""
                }
            </TableContainer>
            
            
            
   
  )
}

export default PurchaseTableBody